import { jsx as t, Fragment as p } from "react/jsx-runtime";
import "react";
import { classes as i } from "../../utils/helpers.js";
import '../../assets/Button.css';const H = "_btn_14dnz_1", o = {
  btn: H,
  "btn--small": "_btn--small_14dnz_26",
  "btn--large": "_btn--large_14dnz_33",
  "btn--primary": "_btn--primary_14dnz_40",
  "btn--action": "_btn--action_14dnz_49",
  "btn--info": "_btn--info_14dnz_58",
  "btn--danger": "_btn--danger_14dnz_67"
};
function z({
  type: h = "button",
  label: e = "",
  href: l = "",
  varient: n = "primary",
  size: b = "",
  classname: d = "",
  customColors: r = {
    bgColor: "",
    bgHoverColor: "",
    color: "",
    hoverColor: "",
    borderColor: "",
    borderHoverColor: ""
  },
  onClick: c = () => {
  },
  ..._
}) {
  const a = n === "" ? "" : `btn--${n}`, g = b === "" ? "" : `btn--${b}`, v = r.bgColor !== "" ? {
    "--button-bg-color": r.bgColor,
    "--button-hover-bg-color": r.bgHoverColor === "" ? r.bgColor : r.bgHoverColor,
    "--button-color": r.color,
    "--button-hover-color": r.hoverColor === "" ? r.color : r.hoverColor,
    "--button-border-color": r.borderColor === "" ? r.bgColor : r.borderColor,
    "--button-hover-border-color": r.borderHoverColor === "" && r.borderColor === "" ? r.bgColor : r.borderHoverColor
  } : null;
  return /* @__PURE__ */ t(p, { children: l === "" ? /* @__PURE__ */ t(
    "button",
    {
      type: h,
      onClick: c,
      className: i([
        d,
        o.btn,
        "btn",
        n === "" ? "" : o[a],
        b === "" ? "" : o[g]
      ]),
      style: v,
      ..._,
      children: e
    }
  ) : /* @__PURE__ */ t(
    "a",
    {
      href: l,
      className: i([
        d,
        o.btn,
        "btn",
        n === "" ? "" : o[a],
        b === "" ? "" : o[g]
      ]),
      style: v,
      ..._,
      children: e
    }
  ) });
}
export {
  z as Button,
  z as default
};
